import { i as o } from "./index778.mjs";
import { c as e } from "./index807.mjs";
import { w as s } from "./index760.mjs";
var i = o, m = e, n = s, l = n("match"), t = function(r) {
  var a;
  return i(r) && ((a = r[l]) !== void 0 ? !!a : m(r) === "RegExp");
};
export {
  t as i
};
